import React, { useEffect } from 'react';
import { Music2 } from 'lucide-react';
import { AudioVisualizer } from './AudioVisualizer';
import { useAudioStream } from '../../hooks/useAudioStream';

export const AudioStreamer = ({ fileId, onRegenerateClick }) => {
  const { bufferState, statusMessage, analyser, startStreaming, cleanupAudio } = useAudioStream(fileId);

  useEffect(() => {
    if (fileId) {
      cleanupAudio();
      startStreaming();
    }
    return () => {
      cleanupAudio();
    };
  }, [fileId, startStreaming, cleanupAudio]);

  return (
    <div className="flex flex-col items-center text-gray-100">
      <div className="relative">
        <AudioVisualizer analyser={analyser} bufferState={bufferState} />
        <div className="absolute bottom-4 left-0 right-0 text-center">
          <span className="px-5 py-2 bg-black/50 rounded-full text-base text-white">
            {statusMessage}
          </span>
        </div>
      </div>
  
      <button
        onClick={onRegenerateClick}
        className="mt-6 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl font-medium 
                 hover:from-purple-600 hover:to-pink-600 transform hover:scale-[1.02] transition-all
                 flex items-center gap-2"
      >
        <Music2 className="w-5 h-5" />
        Generate New Audio
      </button>
    </div>
  );
};